module.exports = __webpack_public_path__ + "static/media/computerCardHeader.546eb3fd.svg";